<style scoped>
    .infoItem{
        background: #fff;
        padding: .24rem;
        /*margin-top: .2rem;*/
        display: flex;
        align-items: center;
        border-bottom: .01rem solid #E9E9E9;

    }

    .infoList .infoItem:last-child{
        border-bottom: none;
    }

    .infoList .zs{
        background: url("~assets/helper.png") no-repeat center/cover;
    }

    .icon{
        width: 1rem;
        height: 1rem;
        background: url("~assets/tx.png") no-repeat center/cover;
        margin-right: .28rem;
        border-radius: 50%;
    }
    .notice{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: .3rem;
        color: #000;
        width: 5.7rem;
    }
    .notice span{
        font-size: .26rem;
        color: #686767;
    }

    .newsBox{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .1rem;
    }

    .content{
        font-size: .26rem;
        color: #686767;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        width: 5rem;
    }

    .news{
        background: #E60012;
        color: #fff;
        font-size: .18rem;
        border-radius: 50%;
        width: .36rem;
        height: .36rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
<template>
    <div class="mainBox" style="padding-top: .98rem">
        <topbar text="消息"></topbar>
        <div class="infoList">
            <div class="infoItem" v-if="isSystemMessage" @click="to(`serviceAssistant`)">
                <div class="icon zs"></div>
                <div class="contentBox">
                    <div class="notice">
                        服务助手
                        <span>{{systemMessage.createTime | time}}</span>
                    </div>
                    <div class="newsBox">
                        <div class="content">{{systemMessage.content}}</div>
                        <div class="news" v-if="systemMessageCount>0">{{systemMessageCount}}</div>
                    </div>
                </div>
            </div>
            <div class="infoItem" @click="to(`reply?bespeakId=${item.bespeakId}`)" v-for="item in userBespeakChatList">
                <div class="icon"></div>
                <div class="contentBox">
                    <div class="notice">
                        {{item.name}}
                        <span>{{item.createTime | time}}</span>
                    </div>
                    <div class="newsBox">
                        <div class="content">{{item.content}}</div>
                        <div class="news" v-if="item.unRead>0">{{item.unRead}}</div>
                    </div>

                </div>
            </div>
            <no-more-data :noMoreData="noMoreData"></no-more-data>
        </div>

        <footerBox active="3"></footerBox>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'
    import footerBox from 'components/footer'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                pageIndex:1,
                pageSize: 25,
                count: 0,
                noMoreData: false,
                isLoading:false,
                userBespeakChatList:[],
                systemMessage: {},
                systemMessageCount: 0 ,
                isSystemMessage: false
            }
        },
        components: {
            noMoreData,
            topbar,
            footerBox
        },
        filters: {

            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            to(n) {
                this.$router.push(`/${n}`)
            },
            async getBespeakChatForDoctor() {
                let data = await getSources("/bear-scale/api/scaleUserBespeakChat/getBespeakChatForDoctor.json", {
                    doctorId:localStorage.getItem('doctorId'),
                    pageSize:this.pageSize,
                    pageIndex:this.pageIndex
                });
                if (data.status === 0) {
                    this.isLoading = false;
                    this.count = data.count;
                    this.userBespeakChatList = [...this.userBespeakChatList, ...data.userBespeakChatList];
                    if (data.userBespeakChatList.length === 0) {
                        this.noMoreData = true
                    } else {
                        console.log(111111)
                        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                            console.log('显示')
                            this.noMoreData = true
                        } else {
                            console.log(2)
                            this.noMoreData = false
                        }
                    }
                }else{
                    alert(data.msg)
                }
            },
            async getLatestMessageForDoctor() {
                let data = await getSources("/bear-scale/api/systemMessage/getLatestMessageForDoctor.json", {
                    doctorId:localStorage.getItem('doctorId')
                });
                if (data.status === 0) {
                    if(data.systemMessage.messageId){
                        this.isSystemMessage=true
                    }
                    this.systemMessage = data.systemMessage;
                    this.systemMessageCount = data.count
                }else{
                    alert(data.msg)
                }
            },
            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getBespeakChatForDoctor()
                    }
                }
            },
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.getBespeakChatForDoctor()
            this.getLatestMessageForDoctor()
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/news.vue